import '../stylesheets/consumer_auth_tailwind.scss';
import IMask from 'imask';

document.addEventListener('DOMContentLoaded', function () {
  const tel = document.querySelector('[data-phone-mask]');
  if (!tel) return;

  const mask = IMask(tel, {
    mask: '(000) 000-0000',
    lazy: false,
    placeholderChar: '_',
    eager: true,
  });

  // Pre-populate from server value (e.g. on validation error re-render)
  const initial = tel.dataset.phoneMask;
  if (initial) {
    mask.unmaskedValue = initial.replace(/\D/g, '');
  }

  function updateColor() {
    tel.classList.toggle('has-value', mask.unmaskedValue.length > 0);
  }

  updateColor();

  mask.on('accept', updateColor);

});
